<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parking-ranger-sessions.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2" [formGroup]="timeForm">
  <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
  <div class="item ms-lg-3 ms-0">
    <label class="control-label">{{'i18n.domain.parking-ranger-sessions.grid.from' | translate}}:</label>
  </div>
  <div class="item ms-lg-3 ms-0">
    <ejs-datepicker id="startTime" formControlName="startTime" format="dd.MM.yyyy" [max]="today"></ejs-datepicker>
  </div>
  <div class="item ms-lg-3 ms-0">
    <label class="control-label">{{'i18n.domain.parking-ranger-sessions.grid.to' | translate}}:</label>
  </div>
  <div class="item ms-lg-3 ms-0">
    <ejs-datepicker id="endTime" formControlName="endTime" format="dd.MM.yyyy" [min]="timeForm.controls.startTime.value" [max]="today"></ejs-datepicker>
  </div>
</div>
@if(showContent) {
  <div class="content-wrapper">
    <div class="content">
      <div class="left">
        <div class="master-header">
          <span class="fw-bold">
            {{'i18n.domain.parking-ranger-sessions.grid.title' | translate}}
          </span>
        </div>
        <ejs-grid #grid
                  class="grid-with-toolbar grid-no-filter master-grid"
                  width="100%"
                  rowHeight="38"
                  [dataSource]="parkingRangerSessions"
                  [allowSorting]="true"
                  [allowFiltering]="true"
                  [filterSettings]="filterSettings"
                  [allowPaging]="true"
                  [pageSettings]="pageSettings"
                  (rowSelected)="rowSelected($event)">
          <e-columns>
            <e-column [headerText]="'i18n.domain.parking-ranger-sessions.grid.date' | translate"
                      field="sessionStartTime"
                      type="date" width="20%"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.sessionStartTime.toFormat('dd.MM.yyyy')}}
              </ng-template>
            </e-column>
            <e-column [headerText]="'i18n.domain.parking-ranger-sessions.grid.from' | translate"
                      field="sessionStartTime"
                      width="20%"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.sessionStartTime.toFormat('HH:mm')}}
              </ng-template>
            </e-column>
            <e-column [headerText]="'i18n.domain.parking-ranger-sessions.grid.to' | translate"
                      field="sessionEndTime"
                      width="20%"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.sessionEndTime ? data.sessionEndTime.toFormat('HH:mm') : 'i18n.domain.parking-ranger-sessions.active' | translate}}
              </ng-template>
            </e-column>
            <e-column [headerText]="'i18n.domain.parking-ranger-sessions.grid.parking-ranger' | translate"
                      field="user.lastname"
                      width="40%"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.user.firstname}} {{data.user.lastname}}
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
      @if(selectedParkingRangerSession) {
        <div class="right">
          <div class="d-lg-flex align-items-center flex-grow space-between">
            <div class="item">
              <label>{{'i18n.domain.parking-ranger-sessions.session-details.date' | translate}}
                {{selectedParkingRangerSession.sessionStartTime.toFormat('dd.MM.yyyy')}}</label>
            </div>
            <div class="item">
              <label>{{'i18n.domain.parking-ranger-sessions.session-details.from' | translate}}
                {{selectedParkingRangerSession.sessionStartTime.toFormat('HH:mm')}}</label>
            </div>
            <div class="item">
              <label>{{'i18n.domain.parking-ranger-sessions.session-details.to' | translate}}
                {{selectedParkingRangerSession.sessionEndTime ?
                selectedParkingRangerSession.sessionEndTime.toFormat('HH:mm') :
                'i18n.domain.parking-ranger-sessions.active' | translate}}</label>
            </div>
            <div class="item">
              <label>{{'i18n.domain.parking-ranger-sessions.grid.parking-ranger' | translate}}
                : {{selectedParkingRangerSession.user.firstname}} {{selectedParkingRangerSession.user.lastname}}</label>
            </div>
          </div>
          <div class="row topLine"></div>
          <div class="row">
            <div class="col-12">
              <div class="e-btn-group align-items-center">
                <button ejs-button (click)="tabToggle(false)" [ngClass]="{'active': tabToggleStatus===false}">
                  {{'i18n.domain.parking-ranger-sessions.controlled-parkers' | translate}}
                </button>
                <button ejs-button (click)="tabToggle(true)" [ngClass]="{'active': tabToggleStatus===true}">
                  {{'i18n.domain.parking-ranger-sessions.map' | translate}}
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
            @if(!tabToggleStatus) {
              <app-parking-ranger-session-details-list [sessionData]="selectedParkingRangerSession">
              </app-parking-ranger-session-details-list>
            } @else {
              <app-map-box-map [isReadOnly]="true"
                               [mapData]="mapData"
                               mapId="rangerSessionMap">
              </app-map-box-map>
            }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
